//#region src/variants/variants_tooltip.js
var variants_tooltip_default = {
	default: {
		props: {
			show: { initialValue: false },
			message: { initialValue: "This is a tooltip" }
		},
		slots: { anchor: { initialValue: "<dt-button>Hover me</dt-button>" } }
	},
	inverted: {
		props: {
			show: { initialValue: false },
			message: { initialValue: "This is a tooltip" },
			inverted: { initialValue: true }
		},
		slots: { anchor: { initialValue: "<dt-button>Hover me</dt-button>" } }
	}
};
//#endregion
export { variants_tooltip_default as default };

//# sourceMappingURL=variants_tooltip.js.map